/**
 * Data object representing the office location list item
 * @note This is usually used in data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class OfficeLocationListItemDataObject {
	/**
	 * @param {string} id - List item's ID.
	 * @param {string} locationName - Location's name.
	 * @param {string} locationAddress - Address of the location.
	 * @param {string} locationPhone - Landline phone number of the location.
	 * @param {string} locationMobile - Mobile phone number of the location.
	 */
	constructor(id, locationName, locationAddress, locationPhone, locationMobile) {
		this.id = id;
		this.locationName = locationName;
		this.locationAddress = locationAddress;
		this.locationPhone = locationPhone;
		this.locationMobile = locationMobile;
	}
}

/**
 * Data object representing the office location item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class OfficeLocationItemDataObject {
	/**
	 * @param {string|null} [id=null] - Item's ID.
	 * @param {string} [locationName=''] - Location's name.
	 * @param {string} [locationAddress=''] - Address of the location.
	 * @param {string} [locationPhone=''] - Landline phone number of the location.
	 * @param {string} [locationMobile=''] - Mobile phone number of the location.
	 */
	constructor(id = null, locationName = '', locationAddress = '', locationPhone = '', locationMobile = '') {
		this.id = id;
		this.locationName = locationName;
		this.locationAddress = locationAddress;
		this.locationPhone = locationPhone;
		this.locationMobile = locationMobile;
	}
}